export default "__VITE_PUBLIC_ASSET__068b9d2b__"